export default __webpack_public_path__ + "static/media/joinTest.d9912b46.jpg";